import OurServicesHeader from './_components/ourservicesheader';
import OurServicesMain from './_components/ourservicesmain';

export default function OurServices() {
  return (
    <div id="ourservices" className="px-6 my-12 mx-auto max-w-7xl">
      <div className="w-full flex flex-col items-center">
        <OurServicesHeader />
      </div>

      <OurServicesMain />
    </div>
  );
}
